// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_fb","menuControls_styleDefault":"c-a_fc","menuControls_styleRed":"c-a_fe"};